import React, { useContext } from "react";
import { OrderContext } from "../../../../contexts/OrderContext";
import OrderDeliveryMap from "./OrderDeliveryMap";
import OrderPreparationStatuses from "./OrderPreparationStatuses";

const OrderStatusDetailsSection = () => {
	const { order } = useContext(OrderContext);

	const shouldRender = () => {
		const hasAnySupportedPreparationStatus =
			Object.entries(order?.preparation_status_changes ?? {}).filter(
				([key, value]) => typeof value === "boolean" && key.toString().includes("supported") && value
			).length > 0;

		if ((!order?.preparation_status_changes || !hasAnySupportedPreparationStatus) && !order?.delivery?.coordinates)
			return false;

		if (!order?.preparation_status_changes || !hasAnySupportedPreparationStatus) {
			if (!order?.delivery?.coordinates || !order?.delivery?.delivery_employee?.coordinates) return false;
		}

		return true;
	};

	if (!shouldRender()) return <></>;

	return (
		<section className="order-delivery-section" data-testid="e-order-status-details-section">
			<OrderDeliveryMap />
			<OrderPreparationStatuses />
		</section>
	);
};

export default OrderStatusDetailsSection;
